var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrainCircuit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#3f3f46",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-brain-circuit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5a2.5 2.5 0 0 0-4.96-.46 2.5 2.5 0 0 0-1.98 3 2.5 2.5 0 0 0-1.32 4.24 3 3 0 0 0 .34 5.58 2.5 2.5 0 0 0 2.96 3.08 2.5 2.5 0 0 0 4.91.05L12 20V4.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8V5c0-1.1.9-2 2-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13h4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18h6a2 2 0 0 1 2 2v1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8h8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 21a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrainCircuit);
export default __webpack_public_path__ + "static/media/brain_circuit.9e73ccc8c221360f7c150fc6505e731f.svg";
export { ForwardRef as ReactComponent };